import React, { memo, forwardRef } from "react";
const SvgNegativeIons = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={9} y={11} fill="#D9D9D9" rx={2} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M20 8.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgNegativeIons.displayName = "SvgNegativeIons";
const MemoForwardRef = memo(SvgNegativeIons);
export default MemoForwardRef;
